import PropTypes from 'prop-types';
import React from 'react';

export default class CustomerInfoSection extends React.Component {
    static propTypes = {
        modifierClass: PropTypes.array,
        title: PropTypes.string,
        description: PropTypes.string,
        
        showAddButton: PropTypes.bool,
        addButtonLabel: PropTypes.string,
        onAddButtonClick: PropTypes.func,
        addButtonUrl: PropTypes.string,

        children: PropTypes.oneOfType([
            PropTypes.arrayOf(PropTypes.node),
            PropTypes.node,
            PropTypes.array
        ]),
    }

    static defaultProps = {
        modifierClass: [],
        title: '',
        description: '',
        addButtonUrl: '',
        children: [],
        showAddButton: false,
        addButtonLabel: 'Lägg till',
        onAddButtonClick: () => {}
    };

    render() {
        const containerClasses = ['member-info-section'].concat(this.props.modifierClass);

        return (
            <div className={containerClasses.join(' ')} data-matomo-mask>
                {this.props.title && (
                    <h2 className="member-info-section__title">{this.props.title}</h2>
                )}
                {this.props.description && (
                    <div className="member-info-section__description"><p>{this.props.description}</p></div>
                )}
                <div className="member-info-section__content">
                    {this.props.children}
                </div>
                <div className="member-info-section__footer">
                    {this.props.showAddButton && (
                        <a
                            className="member-info-section__footer__add-button"
                            onClick={this.props.onAddButtonClick}
                            href={this.props.addButtonUrl}
                        >      
                            <span className="button button--green"> {this.props.addButtonLabel}</span>
                        </a>
                    )}
                </div>
            </div>
        );
    }
};